
import {CasualLeaveVI} from "./casual-leave/vi"

export const CasualAndCompensatoryVI = {
    ...CasualLeaveVI
}